import { useLocation, Link } from "wouter-preact"
import { api_fetch } from "../api/client.tsx"
import { useFormState } from "@/components/form/form_state.tsx"
import { CenterColumnContainer } from "../components/LoginScreen.tsx"
import { useSearchParams } from "@/utils"

import { Button } from "@/components/ui/button.tsx"
import { Logo } from "../app/logo.tsx"
import { Form } from "@/components/form/Form.tsx"
import { PasswordInput } from "@/components/form/Input.tsx"

export function ResetPassword() {
  const [, setLocation] = useLocation()
  const params = useSearchParams<{ token?: string }>()
  const form = useFormState({
    password: "",
    confirmPassword: "",
  })

  if (!params.token) {
    return (
      <CenterColumnContainer title="Invalid Reset Link" logo={<Logo />}>
        <div class="text-center space-y-4">
          <p class="text-red-600">This password reset link is invalid or has expired.</p>
          <Link to="/forgot-password" class="text-blue-600 hover:text-blue-800">
            Request a new password reset link
          </Link>
        </div>
      </CenterColumnContainer>
    )
  }

  async function onSubmit() {
    if (form.password.value !== form.confirmPassword.value) {
      form.set_form_errors(["Passwords do not match"])
      return
    }

    const res = await api_fetch("/auth/reset_password", {
      body: {
        token: params.token,
        password: form.password.value,
      },
    })

    if (!res.ok) {
      form.set_form_errors([res.error.message])
      return
    }

    form.set_form_success("Your password has been reset successfully! You can now log in with your new password.")
    setTimeout(() => {
      setLocation("/login")
    }, 2000)
  }

  return (
    <CenterColumnContainer title="Set New Password" logo={<Logo />}>
      <Form class="space-y-6" onSubmit={onSubmit} alerts={form.form_alerts}>
        <PasswordInput
          label="New Password"
          required={true}
          bind={form.password}
          placeholder="Enter your new password"
        />
        <PasswordInput
          label="Confirm New Password"
          required={true}
          bind={form.confirmPassword}
          placeholder="Confirm your new password"
        />
        <Button type="submit" className="w-full" variant="tertiary">
          Reset Password
        </Button>
      </Form>
      <div class="text-center mt-4">
        <Link to="/login" class="text-sm text-gray-600 hover:text-gray-900">
          Back to login
        </Link>
      </div>
    </CenterColumnContainer>
  )
}
